import {JSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/JSONItemBase";
import PDFArray from "PDFLib/core/objects/PDFArray";
import {JSONFactory} from "PDFLib/core/writers/JSONWriter/JSONFactory";

export class ArrayJSONItem extends JSONItemBase{
    GetType() {
        return 'AJ'
    }

    public Items:JSONItemBase[];
    constructor(item:PDFArray) {
        super();

        this.Items=[];
        for(let currentItem of item.asArray())
        {
            this.Items.push(JSONFactory.GetItem(currentItem));
        }


    }

}